import Breadcrumb from "../Component/Breadcrumb"
import { Link } from 'react-router-dom'
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const Curriculum = () => {
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },

        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" },
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/staff.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Curriculum" breadEnd="Curriculum" breadMid="Curriculum" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">

                            <div class="text-box pdfContainer">
                                <div class="heading">
                                    <h4 className="red-color"> Curriculum 2025-26</h4>
                                </div>

                                <ul>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/AEROMODELLING.pdf" target="_blank" rel="noreferrer">AEROMODELLING-CURRICULUM<i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/ATL.pdf" target="_blank" rel="noreferrer">ATL-CURRICULUM<i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/CREATIVE.pdf" target="_blank" rel="noreferrer">CREATIVE POD-CURRICULUM  <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/Dancepiration.pdf" target="_blank" rel="noreferrer">Dancepiration 9-10-CURRICULUM <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/ECOLIFE.pdf" target="_blank" rel="noreferrer">ECO LIFE-CURRICULUM <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/FITBITS.pdf" target="_blank" rel="noreferrer">FITBITS CURRICULUM<i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/MASTERMINDS.pdf" target="_blank" rel="noreferrer">MASTERMINDS-CURRICULUM  <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/MOTHERTERESA.pdf" target="_blank" rel="noreferrer">MOTHER TERESA- CURRICULUM  <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>

                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/RHYTHM-FUSION.pdf" target="_blank" rel="noreferrer">RHYTHM & FUSION-CURRICULUM <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/SIGMACLUB.pdf" target="_blank" rel="noreferrer">SIGMA CLUB-CURRICULUM<i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/TEDTALK.pdf" target="_blank" rel="noreferrer">TED TALK CLUB- CURRICULUM<i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/UNPARALLED.pdf" target="_blank" rel="noreferrer">UNPARALLED DEVOPS Curriculum <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                </ul>
                             
                                <ul>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/i.pdf" target="_blank" rel="noreferrer">Grade 1 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/ii.pdf" target="_blank" rel="noreferrer">Grade 2 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/iii.pdf" target="_blank" rel="noreferrer">Grade 3 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/iv.pdf" target="_blank" rel="noreferrer">Grade 4 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/v.pdf" target="_blank" rel="noreferrer">Grade 5 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/vi.pdf" target="_blank" rel="noreferrer">Grade 6 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/vii.pdf" target="_blank" rel="noreferrer">Grade 7 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/viii.pdf" target="_blank" rel="noreferrer">Grade 8 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>

                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/ix.pdf" target="_blank" rel="noreferrer">Grade 9 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/x.pdf" target="_blank" rel="noreferrer">Grade 10 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/xi.pdf" target="_blank" rel="noreferrer">Grade 11 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/xii.pdf" target="_blank" rel="noreferrer">Grade 12 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                </ul>

                                <div class="heading">
                                    <h4 className="red-color">FOUNDATIONAL STAGE</h4>
                                </div>
                                <ul>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/FOUNDATIONAL-STAGE-1.pdf" target="_blank" rel="noreferrer">Foundational Stage 1 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/FOUNDATIONAL-STAGE-2.pdf" target="_blank" rel="noreferrer">Foundational Stage  2 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/FOUNDATIONAL-STAGE-3.pdf" target="_blank" rel="noreferrer">Foundational Stage  3 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                </ul>

                                <div class="heading">
                                    <h4 className="red-color"> SPORTS</h4>
                                </div>
                                <ul>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/SPORTS-IV.pdf" target="_blank" rel="noreferrer">Grade 4 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/SPORTS-V.pdf" target="_blank" rel="noreferrer">Grade 5 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/SPORTS-VI.pdf" target="_blank" rel="noreferrer">Grade 6 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/SPORTS-VII.pdf" target="_blank" rel="noreferrer">Grade 7 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                    <li>
                                        <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2025-26/SPORTS-VIII.pdf" target="_blank" rel="noreferrer">Grade 8 <i class="bi bi-file-earmark-pdf"></i></Link>
                                    </li>
                                </ul>
                            </div>
                            <div class="heading">
                                <h4 className="red-color"> Class VI Curriculum 2024-25</h4>
                            </div>
                            <div class="text">
                                <p> <b>As per the guidelines received by CBSE</b></p>
                                <div class="content">
                                    <div class="text-box pdfContainer">
                                        <ul>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/TERM-2_GRADE-VI-MATHEMATICS-CURRICULUM-2024.pdf" target="_blank" rel="noreferrer">MATHEMATICS <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/ASM_SOCIAL-SCIENCE_280679.pdf" target="_blank" rel="noreferrer">SCIENCE <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/TERM-2_GRADE-VI-HINDI-CURRICULUM-2024.pdf" target="_blank" rel="noreferrer">HINDI <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/TERM-2_GRADE-VI-SCIENCE-CURRICULUM-2024.pdf" target="_blank" rel="noreferrer">SCIENCE <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>

                                        </ul>

                                    </div>
                                </div>
                            </div>
                            <div class="heading">
                                <h4 className="red-color"> Curriculum 2024-25</h4>
                            </div>
                            <div class="text">
                                <div class="content">
                                    <div class="text-box pdfContainer">
                                        <ul>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2024-25/iv.pdf" target="_blank" rel="noreferrer">Grade 4 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2024-25/v.pdf" target="_blank" rel="noreferrer">Grade 5 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2024-25/vi.pdf" target="_blank" rel="noreferrer">Grade 6 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2024-25/vii.pdf" target="_blank" rel="noreferrer">Grade 7 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2024-25/viii.pdf" target="_blank" rel="noreferrer">Grade 8 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>



                                        </ul>

                                    </div>
                                </div>
                            </div>
                            <div class="heading">
                                <h4 className="red-color"> Curriculum 2023-24</h4>
                            </div>
                            <div class="text">
                                <div class="content">
                                    <div class="text-box pdfContainer">
                                        <ul>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/pn.pdf" target="_blank" rel="noreferrer">Pre Nursery   <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/nry.pdf" target="_blank" rel="noreferrer">Nursery  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/prep.pdf" target="_blank" rel="noreferrer">Prep  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/i.pdf" target="_blank" rel="noreferrer">Grade 1  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/ii.pdf" target="_blank" rel="noreferrer">Grade 2  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/iii.pdf" target="_blank" rel="noreferrer">Grade 3  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/iv.pdf" target="_blank" rel="noreferrer">Grade 4 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/v.pdf" target="_blank" rel="noreferrer">Grade 5 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/vi.pdf" target="_blank" rel="noreferrer">Grade 6 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/vii.pdf" target="_blank" rel="noreferrer">Grade 7 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/viii.pdf" target="_blank" rel="noreferrer">Grade 8 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/ix.pdf" target="_blank" rel="noreferrer">Grade 9 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/x.pdf" target="_blank" rel="noreferrer">Grade 10 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/xi.pdf" target="_blank" rel="noreferrer">Grade 11 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2023-24/xii.pdf" target="_blank" rel="noreferrer">Grade 12 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>

                                        </ul>

                                    </div>
                                </div>
                            </div>
                            <div class="heading">
                                <h4 className="red-color"> Curriculum 2022-23</h4>
                            </div>
                            <div class="text">
                                <div class="content">
                                    <div class="text-box pdfContainer">
                                        <ul>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/pn.pdf" target="_blank" rel="noreferrer">Pre Nursery   <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/nry.pdf" target="_blank" rel="noreferrer">Nursery  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/prep.pdf" target="_blank" rel="noreferrer">Prep  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/i.pdf" target="_blank" rel="noreferrer">Grade 1  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/ii.pdf" target="_blank" rel="noreferrer">Grade 2  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/iii.pdf" target="_blank" rel="noreferrer">Grade 3  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/iv.pdf" target="_blank" rel="noreferrer">Grade 4  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/v.pdf" target="_blank" rel="noreferrer">Grade 5  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/vi.pdf" target="_blank" rel="noreferrer">Grade 6  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/vii.pdf" target="_blank" rel="noreferrer">Grade 7  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/viii.pdf" target="_blank" rel="noreferrer">Grade 8  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/ix.pdf" target="_blank" rel="noreferrer">Grade 9 <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>
                                            <li>
                                                <Link to="https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/curriculum-2022-23/x.pdf" target="_blank" rel="noreferrer">Grade 10  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>

                                            <li>
                                                <Link to="/" target="_blank" rel="noreferrer">Grade 12  <i class="bi bi-file-earmark-pdf"></i></Link>
                                            </li>

                                        </ul>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Curriculum